import { SizeProp } from "@fortawesome/fontawesome-svg-core";
import { CommodityDetail } from "features/contracts/enums/commodityDetail";
import React, { ReactElement } from "react";
import CommodityIcon from "./CommodityIcon";
import styles from "./commodityiconlist.module.scss";

interface Props {
  commodityDetails: CommodityDetail[];
  includeColor?: boolean;
  iconSize?: SizeProp;
  className?: string;
  isProduction?: boolean;
  dividerClass?: string;
}

const CommodityIconList = ({
  commodityDetails,
  includeColor,
  iconSize,
  className,
  isProduction,
  dividerClass = "mx-1",
}: Props) => {
  // sub-renders
  const renderCommodityIcons = (): JSX.Element[] => {
    let result: JSX.Element[] = [];

    for (let i = 0; i < commodityDetails?.length; i++) {
      const detail = commodityDetails[i];

      if (i > 0) {
        let divider = (
          <span className={`${styles.divider} ${dividerClass}`} key={i + 1}>
            /
          </span>
        );
        result.push(divider);
      }

      let elem = (
        <CommodityIcon
          commodityDetail={detail}
          includeColor={includeColor}
          size={iconSize}
          isProduction={isProduction}
          key={i}
        />
      );
      result.push(elem);
    }

    return result;
  };

  // render
  return <div className={className}>{renderCommodityIcons()}</div>;
};

export default CommodityIconList;
